<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-25 
-->
<template>
  <div class="speaker-item">
    <div class="speaker-img" @click="goDetail">
      <div class="header-img">
        <img :src="itemDetail.logoUrl | logo_show" />
      </div>
      <!-- <div class="comp-logo">
        <img src="" />
      </div> -->
    </div>
    <div class="name" @click="goDetail">{{itemDetail.name | dealLanguage(itemDetail.enName)}}</div>
    <div class="title">{{itemDetail.companyPosition | dealLanguage(itemDetail.enCompanyPosition)}}</div>
  </div>
</template>
<script>
export default {
  inject: ['globalInsertRecords'],
  props: {
    itemDetail: {
      default: () => {},
    },
    sence: {
      default: 1,
    },
  },
  components: {},
  created() {},
  mounted() {},
  data() {
    return {}
  },
  computed: {},
  methods: {
    goDetail() {
      this.globalInsertRecords({
        contentId: this.itemDetail.id,
        contentType: 152,
        viewType: 1
      })
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: this.itemDetail.id,
        },
      })
      // const { href } = this.$router.resolve({
      //   name: 'guestInfo',
      //   params: {
      //     id: item.id,
      //   }
      // })
      // window.open(href)
      // if(this.scene == 2) {
      // }
    },
  },
}
</script>
<style lang='stylus' scoped>
.speaker-item
  width 160px
  max-width 160px
  min-width 160px
  .speaker-img
    position relative
    .header-img
      width 100%
      height 160px
      cursor pointer
      overflow hidden
      img
        width 100%
        height 100%
        object-fit cover
        transition all 0.3s
      &:hover
        img
          transform scale(1.2)
    .comp-logo
      position absolute
      right -10px
      bottom -10px
      width 40px
      height 40px
      background #FFFFFF
      box-shadow 0px 3px 8px 0px rgba(0, 0, 0, 0.16)
      display flex
      align-items center
      justify-content center
      img
        max-width 100%
        max-height 100%
  .name
    display flex
    font-size 18px
    color #333333
    line-height 20px
    margin-top 11px
    cursor pointer
    transition all 0.3s
    &:hover
      color #4E77DF
    &::before
      content ''
      width 2px
      min-width 2px
      max-width 2px
      height 20px
      background #4E77DF
      margin-right 4px
  .title
    margin-top 8px
    font-size 12px
    color #666666
    line-height 18px
</style>